import React from 'react';
import { Alert } from '@mui/material';

const ValidationError = (props) => {
    return (
        <>
            {props.error &&
            <Alert severity="error">
                {props.error.message}
            </Alert>
            }
        </>
    );
};

export default ValidationError;
